import { render, staticRenderFns } from "./CardPaymentMethod.vue?vue&type=template&id=5a46fa72&"
import script from "./CardPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./CardPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports